import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IngresoEgresoVariadoTemplateData } from 'app/model/savingsaccounttransctiontemplate';

@Injectable({
  providedIn: 'root'
})
export class IngresoEgresoVarioServiceService {

  constructor(private http:HttpClient) { }


  /**
   * @param {string} savingAccountId is saving account's Id.
   * @returns {Observable<any>}
   */
   getIngresoEgresoTemplate(): Observable<IngresoEgresoVariadoTemplateData> {
    return this.http.get<IngresoEgresoVariadoTemplateData>(`/tellers/ingresoegresovariado/template`);
  }


  executeIngresoEgresoVarioCommand(command: string, data: any): Observable<any> {
    const httpParams = new HttpParams().set('command', command);
    return this.http.post(`/tellers/ingresoegresovariado`, data, { params: httpParams });
  }


}
